import { Typography, Switch } from '@material-ui/core'
import LastContactDeactivationDialog from './LastContactDeactivationDialog'
import { useDialog } from 'shared/hooks'
import {
  Wrapper,
  ContactValue,
  ContactInfo,
  TitleWrapper,
  InfoWrapper,
} from './Contact.style'
import { HTMLProps } from 'react'

interface ContactProps
  extends Omit<Partial<HTMLProps<HTMLDivElement>>, 'value'> {
  onSwitch: () => void
  isActive: boolean
  icon: JSX.Element
  title: string
  value: string | null
  isTheLastActiveContact?: boolean
  contractorName: string
  isLoading?: boolean
}

const Contact = ({
  onSwitch,
  isActive,
  icon,
  title,
  value,
  contractorName,
  isTheLastActiveContact,
  id,
  isLoading,
}: ContactProps) => {
  const { handleOpen, isDialogOpen, handleClose } = useDialog()

  const handleSwitch = () =>
    isActive && isTheLastActiveContact ? handleOpen() : onSwitch()

  return (
    <Wrapper>
      <ContactInfo>
        <InfoWrapper>
          {icon}
          <Typography>{title}</Typography>
          <TitleWrapper>
            <ContactValue isActive={isActive}>{value}</ContactValue>
          </TitleWrapper>
        </InfoWrapper>
        {value && (
          <Switch checked={isActive} onChange={handleSwitch} id={`${id}-btn`} />
        )}
      </ContactInfo>
      <LastContactDeactivationDialog
        open={isDialogOpen}
        onClose={handleClose}
        isLoading={isLoading}
        onSubmit={async () => {
          await onSwitch()
          handleClose()
        }}
        contractorName={contractorName}
      />
    </Wrapper>
  )
}

export default Contact
